/* eslint-disable no-console */

import { LoggingClient } from "./LoggingClient";

export const tealiumClient = (): LoggingClient => {
    const publish = (eventName: string, eventParams: { [key: string]: string }, testMode: boolean) => {
        if (testMode) {
            console.info(`*** LOGGER *** Log event "${eventName}" with params:`);
            console.table(eventParams);
        }

        if (window.utag) {
            window.utag.link(eventParams);
            if (testMode) console.info(`*** LOGGER *** Successfully logged event "${eventName}".`);
            return;
        }

        const tealiumInterval = window.setInterval(() => {
            if (!window.utag) return;

            window.clearInterval(tealiumInterval);
            window.clearTimeout(tealiumTimeLimit);
            window.utag.link(eventParams);
            if (testMode) console.info(`*** LOGGER *** Successfully logged event "${eventName}".`);
        }, 100);

        const tealiumTimeLimit = window.setTimeout(() => {
            window.clearInterval(tealiumInterval);
            if (testMode) {
                console.error(`*** LOGGER *** FAILED to log event "${eventName}".`);
            } else {
                console.error("Could not access Tealium.");
            }
        }, 3000);
    };

    return { publish };
};
